import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

// NOTE: footer totals are computed from the bookings on the current page only.
// Default page size is large (1000), so in practice a group rarely spans pages,
// but if pagination kicks in these numbers reflect the page, not the group.
const CheckinGroupFooter = ({ checkedIn, total, totalTickets, summaryEntries }) => {
    const { t } = useTranslation();
    return (
        <TableRow sx={{ backgroundColor: 'grey.50', '& td': { fontWeight: 'bold' } }}>
            <TableCell align="center">
                {checkedIn}/{total}
            </TableCell>
            <TableCell>{t('common.total')}</TableCell>
            <TableCell />
            <TableCell>
                {totalTickets}
                {summaryEntries.length > 0 && (
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        component="div"
                        sx={{ fontWeight: 'normal' }}
                    >
                        {summaryEntries.map(([label, count]) => (
                            <div key={label}>{`${count} ${label}`}</div>
                        ))}
                    </Typography>
                )}
            </TableCell>
            <TableCell colSpan={4} />
        </TableRow>
    );
};

export default CheckinGroupFooter;
